<template>
  <div :class="['edit-online-badge', { expanded: hovered }]">
    <img src="https://cdn.vexels.com/img/cursor-click.png" alt="Edit Online Badge" loading="lazy" />
    <span class="badge-text">{{ $t('main.preview.content.editOnline') }}</span>
  </div>
</template>

<script>
export default {
  name: 'EditOnline',
  props: {
    hovered: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
.edit-online-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 10;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: linear-gradient(46.92deg, #3f80f1 -9.64%, #d946ef 108.67%);
  transition: padding 0.3s ease, width 0.3s ease, justify-content 0.3s ease;
  box-sizing: border-box;

  img {
    display: block;
  }

  &.expanded {
    padding: 9px 12px 9px 8.5px;
    width: auto;
    justify-content: flex-start;
  }
}

.badge-text {
  display: none;
  margin: 0;
  font-size: 11px;
  line-height: 14px;
  color: white;
}

.edit-online-badge.expanded .badge-text {
  display: inline-block;
  margin-left: 10px;
}
</style>
